// extracted by mini-css-extract-plugin
module.exports = {"editorContainer":"editor_editorContainer__1RatK","textContainer":"editor_textContainer__2e17t","author":"editor_author__jDC-b","authorlist":"editor_authorlist__1b9n9"};